import { clsx as o } from "clsx";
const c = o;
export { c as cls };